import { useEffect } from "react";

declare global {
  interface Window {
    intlTelInput?: (el: Element, opts: object) => unknown;
  }
}

const ITI_OPTS = {
  initialCountry: "gb",
  separateDialCode: 1,
  allowDropdown: 0,
  nationalMode: 1,
  autoPlaceholder: "aggressive",
  formatOnDisplay: 1,
  utilsScript:
    "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js",
};

function applyIti() {
  if (!window.intlTelInput) return;
  document
    .querySelectorAll<HTMLInputElement>('input[type="tel"]:not([data-iti])')
    .forEach((el) => {
      if (el.closest(".iti")) return;
      el.setAttribute("data-iti", "1");
      window.intlTelInput!(el, ITI_OPTS);
    });
}

export function SdkInit() {
  useEffect(() => {
    const obs = new MutationObserver(applyIti);
    obs.observe(document.body, { childList: true, subtree: true });
    applyIti();
    return () => obs.disconnect();
  }, []);

  return null;
}
